/**
 * auth0-js v9.9.0
 * Author: Auth0
 * Date: 2019-01-10
 * License: MIT
 */
!function (global, factory) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = factory() : "function" == typeof define && define.amd ? define(factory) : global.CordovaAuth0Plugin = factory();
}(this, function () {
  "use strict";

  var version = {
    raw: "9.9.0"
  },
      toString = Object.prototype.toString;

  function attribute(o, attr, type, text) {
    if (type = "array" === type ? "object" : type, o && typeof o[attr] !== type) throw new Error(text);
  }

  function variable(o, type, text) {
    if (typeof o !== type) throw new Error(text);
  }

  function value(o, values, text) {
    if (-1 === values.indexOf(o)) throw new Error(text);
  }

  var assert = {
    check: function check(o, config, attributes) {
      if (config.optional && !o || variable(o, config.type, config.message), "object" === config.type && attributes) for (var keys = Object.keys(attributes), index = 0; index < keys.length; index++) {
        var a = keys[index];
        attributes[a].optional && !o[a] || attributes[a].condition && !attributes[a].condition(o) || (attribute(o, a, attributes[a].type, attributes[a].message), attributes[a].values && value(o[a], attributes[a].values, attributes[a].value_message));
      }
    },
    attribute: attribute,
    variable: variable,
    value: value,
    isArray: function isArray(array) {
      return this.supportsIsArray() ? Array.isArray(array) : "[object Array]" === toString.call(array);
    },
    supportsIsArray: function supportsIsArray() {
      return null != Array.isArray;
    }
  };

  function objectAssignPolyfill(target) {
    if (null == target) throw new TypeError("Cannot convert first argument to object");

    for (var to = Object(target), i = 1; i < arguments.length; i++) {
      var nextSource = arguments[i];
      if (null != nextSource) for (var keysArray = Object.keys(Object(nextSource)), nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
        var nextKey = keysArray[nextIndex],
            desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
        void 0 !== desc && desc.enumerable && (to[nextKey] = nextSource[nextKey]);
      }
    }

    return to;
  }

  var objectAssign = {
    get: function get() {
      return Object.assign ? Object.assign : objectAssignPolyfill;
    },
    objectAssignPolyfill: objectAssignPolyfill
  };

  function pick(object, keys) {
    return keys.reduce(function (prev, key) {
      return object[key] && (prev[key] = object[key]), prev;
    }, {});
  }

  function extend() {
    var params = function (obj) {
      var values = [];

      for (var key in obj) {
        values.push(obj[key]);
      }

      return values;
    }(arguments);

    return params.unshift({}), objectAssign.get().apply(void 0, params);
  }

  function getLocationFromUrl(href) {
    var match = href.match(/^(https?:|file:)\/\/(([^:\/?#]*)(?::([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
    return match && {
      href: href,
      protocol: match[1],
      host: match[2],
      hostname: match[3],
      port: match[4],
      pathname: match[5],
      search: match[6],
      hash: match[7]
    };
  }

  var objectHelper = {
    toSnakeCase: function toSnakeCase(object, exceptions) {
      return "object" != typeof object || assert.isArray(object) || null === object ? object : (exceptions = exceptions || [], Object.keys(object).reduce(function (p, key) {
        return p[-1 === exceptions.indexOf(key) ? function (str) {
          for (var code, newKey = "", index = 0, wasPrevNumber = !0, wasPrevUppercase = !0; index < str.length;) {
            code = str.charCodeAt(index), !wasPrevUppercase && code >= 65 && code <= 90 || !wasPrevNumber && code >= 48 && code <= 57 ? (newKey += "_", newKey += str[index].toLowerCase()) : newKey += str[index].toLowerCase(), wasPrevNumber = code >= 48 && code <= 57, wasPrevUppercase = code >= 65 && code <= 90, index++;
          }

          return newKey;
        }(key) : key] = toSnakeCase(object[key]), p;
      }, {}));
    },
    toCamelCase: function toCamelCase(object, exceptions) {
      return "object" != typeof object || assert.isArray(object) || null === object ? object : (exceptions = exceptions || [], Object.keys(object).reduce(function (p, key) {
        var parts;
        return p[-1 === exceptions.indexOf(key) ? (parts = key.split("_")).reduce(function (p, c) {
          return p + c.charAt(0).toUpperCase() + c.slice(1);
        }, parts.shift()) : key] = toCamelCase(object[key]), p;
      }, {}));
    },
    blacklist: function blacklist(object, blacklistedKeys) {
      return Object.keys(object).reduce(function (p, key) {
        return -1 === blacklistedKeys.indexOf(key) && (p[key] = object[key]), p;
      }, {});
    },
    merge: function merge(object, keys) {
      return {
        base: keys ? pick(object, keys) : object,
        with: function _with(object2, keys2) {
          return object2 = keys2 ? pick(object2, keys2) : object2, extend(this.base, object2);
        }
      };
    },
    pick: pick,
    getKeysNotIn: function getKeysNotIn(obj, allowedKeys) {
      var notAllowed = [];

      for (var key in obj) {
        -1 === allowedKeys.indexOf(key) && notAllowed.push(key);
      }

      return notAllowed;
    },
    extend: extend,
    getOriginFromUrl: function getOriginFromUrl(url) {
      if (url) {
        var parsed = getLocationFromUrl(url),
            origin = parsed.protocol + "//" + parsed.hostname;
        return parsed.port && (origin += ":" + parsed.port), origin;
      }
    },
    getLocationFromUrl: getLocationFromUrl
  };

  function getWindow() {
    return window;
  }

  var windowHandler = {
    redirect: function redirect(url) {
      getWindow().location = url;
    },
    getDocument: function getDocument() {
      return getWindow().document;
    },
    getWindow: getWindow,
    getOrigin: function getOrigin() {
      var location = getWindow().location,
          origin = location.origin;
      return origin || (origin = objectHelper.getOriginFromUrl(location.href)), origin;
    }
  },
      commonjsGlobal = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

  function createCommonjsModule(fn, module) {
    return fn(module = {
      exports: {}
    }, module.exports), module.exports;
  }

  var urlJoin = createCommonjsModule(function (module) {
    var context, definition;
    context = commonjsGlobal, definition = function definition() {
      return function () {
        return function (strArray) {
          var resultArray = [];

          if (strArray[0].match(/^[^\/:]+:\/*$/) && strArray.length > 1) {
            var first = strArray.shift();
            strArray[0] = first + strArray[0];
          }

          strArray[0].match(/^file:\/\/\//) ? strArray[0] = strArray[0].replace(/^([^\/:]+):\/*/, "$1:///") : strArray[0] = strArray[0].replace(/^([^\/:]+):\/*/, "$1://");

          for (var i = 0; i < strArray.length; i++) {
            var component = strArray[i];
            if ("string" != typeof component) throw new TypeError("Url must be a string. Received " + component);
            "" !== component && (i > 0 && (component = component.replace(/^[\/]+/, "")), component = i < strArray.length - 1 ? component.replace(/[\/]+$/, "") : component.replace(/[\/]+$/, "/"), resultArray.push(component));
          }

          var str = resultArray.join("/"),
              parts = (str = str.replace(/\/(\?|&|#[^!])/g, "$1")).split("?");
          return str = parts.shift() + (parts.length > 0 ? "?" : "") + parts.join("&");
        }("object" == typeof arguments[0] ? arguments[0] : [].slice.call(arguments));
      };
    }, module.exports ? module.exports = definition() : context.urljoin = definition();
  }),
      utils = createCommonjsModule(function (module, exports) {
    var has = Object.prototype.hasOwnProperty,
        hexTable = function () {
      for (var array = [], i = 0; i < 256; ++i) {
        array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
      }

      return array;
    }();

    exports.arrayToObject = function (source, options) {
      for (var obj = options && options.plainObjects ? Object.create(null) : {}, i = 0; i < source.length; ++i) {
        void 0 !== source[i] && (obj[i] = source[i]);
      }

      return obj;
    }, exports.merge = function (target, source, options) {
      if (!source) return target;

      if ("object" != typeof source) {
        if (Array.isArray(target)) target.push(source);else {
          if ("object" != typeof target) return [target, source];
          (options.plainObjects || options.allowPrototypes || !has.call(Object.prototype, source)) && (target[source] = !0);
        }
        return target;
      }

      if ("object" != typeof target) return [target].concat(source);
      var mergeTarget = target;
      return Array.isArray(target) && !Array.isArray(source) && (mergeTarget = exports.arrayToObject(target, options)), Array.isArray(target) && Array.isArray(source) ? (source.forEach(function (item, i) {
        has.call(target, i) ? target[i] && "object" == typeof target[i] ? target[i] = exports.merge(target[i], item, options) : target.push(item) : target[i] = item;
      }), target) : Object.keys(source).reduce(function (acc, key) {
        var value = source[key];
        return Object.prototype.hasOwnProperty.call(acc, key) ? acc[key] = exports.merge(acc[key], value, options) : acc[key] = value, acc;
      }, mergeTarget);
    }, exports.decode = function (str) {
      try {
        return decodeURIComponent(str.replace(/\+/g, " "));
      } catch (e) {
        return str;
      }
    }, exports.encode = function (str) {
      if (0 === str.length) return str;

      for (var string = "string" == typeof str ? str : String(str), out = "", i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);
        45 === c || 46 === c || 95 === c || 126 === c || c >= 48 && c <= 57 || c >= 65 && c <= 90 || c >= 97 && c <= 122 ? out += string.charAt(i) : c < 128 ? out += hexTable[c] : c < 2048 ? out += hexTable[192 | c >> 6] + hexTable[128 | 63 & c] : c < 55296 || c >= 57344 ? out += hexTable[224 | c >> 12] + hexTable[128 | c >> 6 & 63] + hexTable[128 | 63 & c] : (i += 1, c = 65536 + ((1023 & c) << 10 | 1023 & string.charCodeAt(i)), out += hexTable[240 | c >> 18] + hexTable[128 | c >> 12 & 63] + hexTable[128 | c >> 6 & 63] + hexTable[128 | 63 & c]);
      }

      return out;
    }, exports.compact = function (obj, references) {
      if ("object" != typeof obj || null === obj) return obj;
      var refs = references || [],
          lookup = refs.indexOf(obj);
      if (-1 !== lookup) return refs[lookup];

      if (refs.push(obj), Array.isArray(obj)) {
        for (var compacted = [], i = 0; i < obj.length; ++i) {
          obj[i] && "object" == typeof obj[i] ? compacted.push(exports.compact(obj[i], refs)) : void 0 !== obj[i] && compacted.push(obj[i]);
        }

        return compacted;
      }

      return Object.keys(obj).forEach(function (key) {
        obj[key] = exports.compact(obj[key], refs);
      }), obj;
    }, exports.isRegExp = function (obj) {
      return "[object RegExp]" === Object.prototype.toString.call(obj);
    }, exports.isBuffer = function (obj) {
      return null != obj && !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
    };
  }),
      replace = (utils.arrayToObject, utils.merge, utils.decode, utils.encode, utils.compact, utils.isRegExp, utils.isBuffer, String.prototype.replace),
      percentTwenties = /%20/g,
      formats = {
    default: "RFC3986",
    formatters: {
      RFC1738: function RFC1738(value) {
        return replace.call(value, percentTwenties, "+");
      },
      RFC3986: function RFC3986(value) {
        return value;
      }
    },
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
  },
      arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
      return prefix + "[]";
    },
    indices: function indices(prefix, key) {
      return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
      return prefix;
    }
  },
      toISO = Date.prototype.toISOString,
      defaults = {
    delimiter: "&",
    encode: !0,
    encoder: utils.encode,
    encodeValuesOnly: !1,
    serializeDate: function serializeDate(date) {
      return toISO.call(date);
    },
    skipNulls: !1,
    strictNullHandling: !1
  },
      stringify = function stringify(object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly) {
    var obj = object;
    if ("function" == typeof filter) obj = filter(prefix, obj);else if (obj instanceof Date) obj = serializeDate(obj);else if (null === obj) {
      if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix) : prefix;
      obj = "";
    }
    if ("string" == typeof obj || "number" == typeof obj || "boolean" == typeof obj || utils.isBuffer(obj)) return encoder ? [formatter(encodeValuesOnly ? prefix : encoder(prefix)) + "=" + formatter(encoder(obj))] : [formatter(prefix) + "=" + formatter(String(obj))];
    var objKeys,
        values = [];
    if (void 0 === obj) return values;
    if (Array.isArray(filter)) objKeys = filter;else {
      var keys = Object.keys(obj);
      objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0; i < objKeys.length; ++i) {
      var key = objKeys[i];
      skipNulls && null === obj[key] || (values = Array.isArray(obj) ? values.concat(stringify(obj[key], generateArrayPrefix(prefix, key), generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly)) : values.concat(stringify(obj[key], prefix + (allowDots ? "." + key : "[" + key + "]"), generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly)));
    }

    return values;
  },
      lib_stringify = (Object.prototype.hasOwnProperty, utils.decode, function (object, opts) {
    var obj = object,
        options = opts || {};
    if (null !== options.encoder && void 0 !== options.encoder && "function" != typeof options.encoder) throw new TypeError("Encoder has to be a function.");
    var delimiter = void 0 === options.delimiter ? defaults.delimiter : options.delimiter,
        strictNullHandling = "boolean" == typeof options.strictNullHandling ? options.strictNullHandling : defaults.strictNullHandling,
        skipNulls = "boolean" == typeof options.skipNulls ? options.skipNulls : defaults.skipNulls,
        encode = "boolean" == typeof options.encode ? options.encode : defaults.encode,
        encoder = "function" == typeof options.encoder ? options.encoder : defaults.encoder,
        sort = "function" == typeof options.sort ? options.sort : null,
        allowDots = void 0 !== options.allowDots && options.allowDots,
        serializeDate = "function" == typeof options.serializeDate ? options.serializeDate : defaults.serializeDate,
        encodeValuesOnly = "boolean" == typeof options.encodeValuesOnly ? options.encodeValuesOnly : defaults.encodeValuesOnly;
    if (void 0 === options.format) options.format = formats.default;else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) throw new TypeError("Unknown format option provided.");
    var objKeys,
        filter,
        formatter = formats.formatters[options.format];
    "function" == typeof options.filter ? obj = (filter = options.filter)("", obj) : Array.isArray(options.filter) && (objKeys = filter = options.filter);
    var arrayFormat,
        keys = [];
    if ("object" != typeof obj || null === obj) return "";
    arrayFormat = options.arrayFormat in arrayPrefixGenerators ? options.arrayFormat : "indices" in options ? options.indices ? "indices" : "repeat" : "indices";
    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
    objKeys || (objKeys = Object.keys(obj)), sort && objKeys.sort(sort);

    for (var i = 0; i < objKeys.length; ++i) {
      var key = objKeys[i];
      skipNulls && null === obj[key] || (keys = keys.concat(stringify(obj[key], key, generateArrayPrefix, strictNullHandling, skipNulls, encode ? encoder : null, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly)));
    }

    return keys.join(delimiter);
  });

  function PopupHandler(webAuth) {
    this.webAuth = webAuth, this._current_popup = null, this.options = null;
  }

  function PluginHandler(webAuth) {
    this.webAuth = webAuth;
  }

  function CordovaPlugin() {
    this.webAuth = null, this.version = version.raw, this.extensibilityPoints = ["popup.authorize", "popup.getPopupHandler"];
  }

  return PopupHandler.prototype.preload = function (options) {
    var _this = this,
        _window = windowHandler.getWindow(),
        url = options.url || "about:blank",
        popupOptions = options.popupOptions || {};

    popupOptions.location = "yes", delete popupOptions.width, delete popupOptions.height;
    var windowFeatures = lib_stringify(popupOptions, {
      encode: !1,
      delimiter: ","
    });
    return this._current_popup && !this._current_popup.closed ? this._current_popup : (this._current_popup = _window.open(url, "_blank", windowFeatures), this._current_popup.kill = function (success) {
      _this._current_popup.success = success, this.close(), _this._current_popup = null;
    }, this._current_popup);
  }, PopupHandler.prototype.load = function (url, _, options, cb) {
    var _this = this;

    this.url = url, this.options = options, this._current_popup ? this._current_popup.location.href = url : (options.url = url, this.preload(options)), this.transientErrorHandler = function (event) {
      _this.errorHandler(event, cb);
    }, this.transientStartHandler = function (event) {
      _this.startHandler(event, cb);
    }, this.transientExitHandler = function () {
      _this.exitHandler(cb);
    }, this._current_popup.addEventListener("loaderror", this.transientErrorHandler), this._current_popup.addEventListener("loadstart", this.transientStartHandler), this._current_popup.addEventListener("exit", this.transientExitHandler);
  }, PopupHandler.prototype.errorHandler = function (event, cb) {
    this._current_popup && (this._current_popup.kill(!0), cb({
      error: "window_error",
      errorDescription: event.message
    }));
  }, PopupHandler.prototype.unhook = function () {
    this._current_popup.removeEventListener("loaderror", this.transientErrorHandler), this._current_popup.removeEventListener("loadstart", this.transientStartHandler), this._current_popup.removeEventListener("exit", this.transientExitHandler);
  }, PopupHandler.prototype.exitHandler = function (cb) {
    this._current_popup && (this.unhook(), this._current_popup.success || cb({
      error: "window_closed",
      errorDescription: "Browser window closed"
    }));
  }, PopupHandler.prototype.startHandler = function (event, cb) {
    var _this = this;

    if (this._current_popup) {
      var callbackUrl = urlJoin("https:", this.webAuth.baseOptions.domain, "/mobile");

      if (!event.url || 0 === event.url.indexOf(callbackUrl + "#")) {
        var parts = event.url.split("#");

        if (1 !== parts.length) {
          var opts = {
            hash: parts.pop()
          };
          this.options.nonce && (opts.nonce = this.options.nonce), this.webAuth.parseHash(opts, function (error, result) {
            (error || result) && (_this._current_popup.kill(!0), cb(error, result));
          });
        }
      }
    }
  }, PluginHandler.prototype.processParams = function (params) {
    return params.redirectUri = urlJoin("https://" + params.domain, "mobile"), delete params.owp, params;
  }, PluginHandler.prototype.getPopupHandler = function () {
    return new PopupHandler(this.webAuth);
  }, CordovaPlugin.prototype.setWebAuth = function (webAuth) {
    this.webAuth = webAuth;
  }, CordovaPlugin.prototype.supports = function (extensibilityPoint) {
    var _window = windowHandler.getWindow();

    return (!!_window.cordova || !!_window.electron) && this.extensibilityPoints.indexOf(extensibilityPoint) > -1;
  }, CordovaPlugin.prototype.init = function () {
    return new PluginHandler(this.webAuth);
  }, CordovaPlugin;
});